import React from 'react';

//Componentes
import TableContainer from '../table/TableContainer';

//Estilos
import './DJMVSearch.css';

function DJMVSearch({ tableData }) {
    return (
        <div className="DJMV_search-container">
            {tableData.data.length > 0 ? (
                <TableContainer tableData={tableData} />
            ) : (
                <h4>No se encontraron resultados para DJMV</h4>
            )}
        </div>
    );
}

export default DJMVSearch;
